import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {NavLink} from 'react-router-dom';
import {updateAccount} from '../../account/action/accountActions';
import accountApi from '../../account/api/accountApi';
import '../../styles/icon.less';
import StacyLogo from '../img/stacy-logo.svg';
import '../style/TopBar.less';
import {Nav, NavbarBrand} from 'react-bootstrap';
import NavbarToggle from 'react-bootstrap/NavbarToggle';
import NavbarCollapse from 'react-bootstrap/NavbarCollapse';
import AccountRoles from '../../account/enums/AccountRoles';
import {resetOverviewFilters} from '../../training/action/trainingActions';

function TopBar() {

    const hideNavBar = useSelector(state => state.navigation.hideNavBar);
    const isLoggedIn = useSelector(state => state.account.isLoggedIn);
    const role = useSelector(state => state.account.role);
    const allClubs = useSelector(state => state.account.clubs);
    const dispatch = useDispatch();
    const [t] = useTranslation();

    function handleLogout(e) {
        e.preventDefault();
        accountApi.logout().then(() => {
            window.sessionStorage.removeItem('api-key');
            dispatch(updateAccount(null));
            dispatch(resetOverviewFilters());
        });
    }

    let clubLink = '/clubs';
    if (allClubs && allClubs.length === 1) {
        clubLink = `/club/${allClubs[0].id}`;
    }

    return (
        <>
            {
                !hideNavBar &&
                <header>
                    <Navbar className="top-bar" variant="dark" id="header" expand="lg" fixed="top">
                        <NavbarBrand href="/dashboard" id="stacey-logo">
                            <img src={StacyLogo} alt="Stacy Logo"/>
                        </NavbarBrand>
                        {
                            isLoggedIn &&
                            <>
                                <NavbarToggle className="ml-auto" aria-controls="basic-navbar-nav"/>
                                <NavbarCollapse id="basic-navbar-nav">
                                    <Nav className="mr-auto">
                                        <NavLink className="button-text" exact={true} to="/trainings">
                                            <FontAwesomeIcon icon="chart-bar" className="mr-2"/>
                                            {t('Navigation.TRAINING')}
                                        </NavLink>

                                        <NavLink className="button-text" exact={true} to={clubLink}>
                                            <FontAwesomeIcon icon="chart-bar" className="mr-2"/>
                                            {role === AccountRoles.ADMINISTRATOR ? t('Navigation.CLUB_MANAGEMENT') : t('Navigation.CLUB_MANAGEMENT_SINGLE')}
                                        </NavLink>
                                    </Nav>
                                    <Nav className="ml-auto">
                                        <NavLink to="/login" className="align-right nav-link" onClick={handleLogout}>
                                            <FontAwesomeIcon icon="sign-out-alt" className="mr-1"/>
                                            {t('Navigation.LOGOUT')}
                                        </NavLink>
                                    </Nav>
                                </NavbarCollapse>
                            </>
                        }
                        {
                            !isLoggedIn &&
                            <>
                                <NavbarToggle className="ml-auto" aria-controls="basic-navbar-nav"/>
                                <NavbarCollapse id="basic-navbar-nav">
                                    <Nav className="ml-auto">
                                        <NavLink className="align-right nav-link" exact={true} to="/login">
                                            {t('Navigation.LOGIN')}
                                        </NavLink>
                                        <NavLink className="align-right nav-link" exact={true} to="/register">
                                            {t('Navigation.REGISTER')}
                                        </NavLink>
                                    </Nav>
                                </NavbarCollapse>
                            </>
                        }
                    </Navbar>
                </header>
            }
        </>
    );
}

export default TopBar;
